module.exports = __webpack_public_path__ + "img/17.cdd12638.png";